import React from "react";
import { Layout, Button, Tooltip, Affix } from "antd";
import { CloseOutlined } from "@ant-design/icons";

const styles = {
  widget: {
    position: "fixed",
    // marginLeft: "50%",
    // marginRight: "50%",
    display: "inline-block",
    left: "50%",
    transform: "translateX(-50%)",
  },
  assistanceMode: {
    position: "fixed",
    top: 0,

    zIndex: 2000,
  },
};

export const AssistanceModeLayout = ({
  isAssistanceMode,
  setIsAssistanceMode,
}) =>
  isAssistanceMode && (
    <div style={styles.assistanceMode}>
      <Layout>
        <div style={{ ...styles.widget }}>
          <Affix offsetTop={10}>
            <div style={{ display: "inline-flex" }}>
              <Button style={{ marginLeft: -10 }} type="primary" shape="round">
                Assistance Mode
              </Button>
              <Tooltip title={"End Assistance Mode"}>
                <Button
                  style={{ marginLeft: 10 }}
                  type="danger"
                  shape="circle"
                  icon={<CloseOutlined />}
                  onClick={() => {
                    setIsAssistanceMode(false);
                  }}
                ></Button>
              </Tooltip>
            </div>
          </Affix>
        </div>
      </Layout>
    </div>
  );

export default AssistanceModeLayout;
